import { useState as f, useEffect as h } from "react";
import { breakpointQueries as k } from "./index38.mjs";
import { getCurrentBreakpoints as s } from "./index39.mjs";
const g = (i) => {
  const a = i ?? s(), [c, r] = f(
    () => a
  );
  return h(() => {
    const m = s();
    r(m);
    const p = Object.entries(k).map(([e, t]) => {
      const n = window.matchMedia(t), o = (u) => r((d) => ({ ...d, [e]: u.matches }));
      return n.addEventListener("change", o), { mediaQuery: n, handler: o };
    });
    return () => p.forEach(
      ({ mediaQuery: e, handler: t }) => e.removeEventListener("change", t)
    );
  }, []), { ...c };
};
export {
  g as useMediaQuery
};
